var map = {
	"./1102 Boba Bunny.webp": 5257,
	"./1102 Combo Platter.webp": 5819,
	"./1102 Matcha Iceblend.webp": 2691,
	"./1102 TOTE.webp": 7429,
	"./Almond Milktea.webp": 8697,
	"./Almond Mocha Iceblend.webp": 4670,
	"./Avocado Smoothies.webp": 339,
	"./BEEF Ball.webp": 3996,
	"./Berries Smoothies.webp": 4626,
	"./Black Milktea.webp": 1059,
	"./Blue Ocean - Blue Curacao Italian.webp": 6138,
	"./Boba Milk - Brulee On The Tiger.webp": 9349,
	"./Boba Milk - Chocolate Boba Milk.webp": 8038,
	"./Boba Milk - Honey Boba Milk.webp": 4995,
	"./Boba Milk - Matcha Boba Milk.webp": 2170,
	"./Boba Milk - Orange Boba Milk.webp": 2424,
	"./Boba Milk - Strawberry Boba Milk.webp": 3007,
	"./Boba Milk - Tige Sugar Boba Milk.webp": 2847,
	"./Boba Milk - Tiger Sugar Boba Milk.webp": 6789,
	"./Brulee On The Tiger.webp": 5319,
	"./CHAI TEA Pumpkin Latte.webp": 5140,
	"./CHICKEN Dumpling.webp": 3614,
	"./CREME BRULEE.webp": 9036,
	"./Caramel MILKTEA.webp": 1757,
	"./Caramel Mocha Iceblend.webp": 1794,
	"./Cheese Stick.webp": 4676,
	"./Chocolate Boba Milk.webp": 7168,
	"./Chocolate Cookies.webp": 9938,
	"./Chocolate MILKTEA.webp": 5386,
	"./Chocolate Matcha Iceblend.webp": 6791,
	"./Chocolate Mocha Iceblend.webp": 4647,
	"./Chocolate Pumpkin MOCHA.webp": 5275,
	"./Cinnamon Pumpkin MILKTEA.webp": 2585,
	"./Coconut Coffee.webp": 1332,
	"./Coconut Cookies.webp": 9247,
	"./Coconut MILKTEA.webp": 523,
	"./Coconut Mocha Iceblend.webp": 452,
	"./Coffee - Coconut Coffee.webp": 5911,
	"./Coffee - Coffee latte.webp": 1700,
	"./Coffee - Egg Coffee.webp": 4169,
	"./Coffee - Macchiato coffee.webp": 3043,
	"./Coffee - Matcha Coffee.webp": 5258,
	"./Coffee - Mocha.webp": 8940,
	"./Coffee - Salted Caramel Coffee.webp": 8434,
	"./Coffee - Ube Coffee.webp": 4860,
	"./Coffee - Vietnamese Black Coffee.webp": 4722,
	"./Coffee - Vietnamese Milk Coffee.webp": 6084,
	"./Coffee Latte.webp": 9543,
	"./Coffee MILKTEA.webp": 1042,
	"./De Lavie - Honeydew FRECH.webp": 2661,
	"./De Lune - Mango FRENCH.webp": 619,
	"./De Soleil - Pineapple FRENCH.webp": 4609,
	"./De Valentino - Strawberry.webp": 806,
	"./Dragonfruit Tea.webp": 3090,
	"./Dua hau.webp": 9627,
	"./EGG Coffee.webp": 1350,
	"./Egg Roll.webp": 9557,
	"./FISH Ball.webp": 1220,
	"./FLAN.webp": 7264,
	"./French Smoothies - Yogurt Honeydew Peach.webp": 9693,
	"./French Smoothies - Yogurt Mango Orange.webp": 4209,
	"./French Smoothies - Yogurt Pineapple Peppermint.webp": 155,
	"./French Smoothies - Yogurt Strawberry Mango.webp": 4578,
	"./French Sodas - De Lavie (Honeydrew).webp": 9506,
	"./French Sodas - De Lune (Mango).webp": 4686,
	"./French Sodas - De Soleil (Pineapple).webp": 2384,
	"./French Sodas - De Valentino (Strawberry).webp": 5917,
	"./GREEN APPLE TEAMILKTEA.webp": 9261,
	"./Grapefruit TEA.webp": 8628,
	"./Green Apple Tea.webp": 2874,
	"./Greenthai milktea.webp": 8333,
	"./Grilled Egg Cake (Banh Trung Nuong).webp": 8184,
	"./Guava Tea.webp": 479,
	"./HAT.webp": 1586,
	"./Hand mash Strawberry Tea.webp": 7892,
	"./Hazelnut MILKTEA.webp": 9875,
	"./Hazelnut Mocha Iceblend.webp": 3980,
	"./Honey Boba Milk.webp": 5021,
	"./Honey Lemon Tea.webp": 4257,
	"./Honey Matcha Iceblend.webp": 9802,
	"./Hot Fire Bread (Banh Mi Muoi Ot).webp": 3387,
	"./Iceblend - 1102 Matcha.webp": 7416,
	"./Iceblend - Chocolate Cookies.webp": 2961,
	"./Iceblend - Chocolate Matcha.webp": 3222,
	"./Iceblend - Coconut Cookies.webp": 9388,
	"./Iceblend - Honey Matcha.webp": 1457,
	"./Iceblend - Peppermint Cookies.webp": 9363,
	"./Iceblend - Yogurt Cookies.webp": 9369,
	"./Iceblend - Yogurt Matcha.webp": 9278,
	"./Italian Sodas - Blue Ocean (Blue Curacao).webp": 9173,
	"./Italian Sodas - Pinky Dream (Rose).webp": 8820,
	"./Italian Sodas - Ruby (Grapefruit).webp": 3768,
	"./Italian Sodas - Sapphire (Lavender).webp": 8614,
	"./Italian Sodas - Sunrise (Mango).webp": 5780,
	"./Italian Sodas - Sunset (Orange).webp": 9053,
	"./JASMINE GREEN MILKTEA.webp": 5838,
	"./Key chain Bunny.webp": 9673,
	"./LAVENDER TEA.webp": 3688,
	"./Large size Bunny Plushie.webp": 4263,
	"./Lavender MILKTEA.webp": 2445,
	"./Lavender TEA (2).webp": 8505,
	"./Lemon Sorbet.webp": 2347,
	"./Lemonade Jasmine Tea.webp": 8943,
	"./Luu.webp": 645,
	"./Lychee MILKTEA.webp": 5672,
	"./Lychee TEA.webp": 1297,
	"./MANGO MILK TEA.webp": 4222,
	"./MAPLE Pumpkin Latte.webp": 5280,
	"./MATCHA Coffee.webp": 191,
	"./MILKTEA ON THE FIRE.webp": 4874,
	"./Macaroon.webp": 1309,
	"./Macchiato Coffee.webp": 8412,
	"./Macchiato TEA.webp": 6146,
	"./Macchiato Tea - Black tea.webp": 5164,
	"./Macchiato Tea - Jasmine tea.webp": 9258,
	"./Macchiato Tea - Oolong Tea.webp": 209,
	"./Macchiato Tea - Strawberry Macchiato.webp": 9801,
	"./Mango Smoothies.webp": 3524,
	"./Mango Sorbet.webp": 9348,
	"./Mango TEA.webp": 7003,
	"./Matcha Boba Milk.webp": 2092,
	"./Matcha MILKTEA.webp": 158,
	"./Mayo Springroll (Banh Trang Cuon Bo).webp": 809,
	"./Medium size Bunny Plushie.webp": 2521,
	"./Milktea.webp": 7296,
	"./Mocha Coffee.webp": 3303,
	"./Mocha Iceblend - Almond Mocha.webp": 7519,
	"./Mocha Iceblend - Caramel Mocha.webp": 5449,
	"./Mocha Iceblend - Chocolate Mocha.webp": 8810,
	"./Mocha Iceblend - Coconut Mocha.webp": 3207,
	"./Mocha Iceblend - Hazelnut Mocha.webp": 217,
	"./Mocha Iceblend - Tiramisu Mocha.webp": 4304,
	"./OOLONG MILKTEA ( DARK ROAST).webp": 3934,
	"./OOLONG MILKTEA (DARK ROAST).webp": 1450,
	"./ORANGE MILKTEA.webp": 3484,
	"./Orange Boba Milk.webp": 1646,
	"./Orange Sorbet.webp": 1674,
	"./Organic Milktea - Dark Roast Oolong.webp": 1985,
	"./Organic Milktea - Earl Grey Black.webp": 7426,
	"./Organic Milktea - Green Thai.webp": 4821,
	"./Organic Milktea - Jasmine Green Tea.webp": 5270,
	"./Organic Milktea - Milktea On The Fire.webp": 5207,
	"./Organic Milktea - Plant Pot Milktea.webp": 9427,
	"./Organic Milktea - Red Thai.webp": 5065,
	"./Organic Milktea - Wonderland Milktea.webp": 6411,
	"./PANNA COTTA.webp": 8284,
	"./PHA LAU.webp": 8730,
	"./PLANT POT MILKTEA.webp": 5962,
	"./Peach Jasmine MACCHIATO TEA.webp": 5454,
	"./Peach MILKTEA.webp": 5093,
	"./Peach ORANGE LEMONGRASS Jasmine TEA.webp": 3052,
	"./Peach PASSIONFRUIT Jasmine TEA.webp": 3656,
	"./Peach Series - Peach Jasmine Macchiato Tea.webp": 4301,
	"./Peach Series - Peach Orange Lemongrass Jasmine Tea.webp": 9155,
	"./Peach Series - Peach Passionfruit Jasmine Tea.webp": 3669,
	"./Peach Series - Tropical Peach Mango Yogurt.webp": 7047,
	"./Peach TEA.webp": 672,
	"./Peppermint Cookies.webp": 6958,
	"./Peppermint Tea.webp": 4699,
	"./Pinky Dream - Rose ITALIAN.webp": 1975,
	"./RED THAI MILKTEA.webp": 5,
	"./Red Thai Milk Tea.webp": 2159,
	"./Rice Paper On the WOK (Banh Trang Chien).webp": 7430,
	"./Rice Paper Pot Sticker.webp": 7777,
	"./Rice Paper Salad (Banh Trang Tron).webp": 9976,
	"./Rice Paper Tacos (Banh Trang Nuong).webp": 5123,
	"./Rose MILKTEA.webp": 6533,
	"./Rose TEA.webp": 4128,
	"./Ruby - Grapefruit ITALIAN.webp": 1349,
	"./SALTED CARAMEL COFFEE.webp": 6611,
	"./SHRIMP Ball.webp": 8435,
	"./SOURSOP JASMINE TEA.webp": 3177,
	"./STRAWBERRY MILKTEA.webp": 3531,
	"./Sapphire - Lavender ITALIAN.webp": 5387,
	"./Sausage.webp": 464,
	"./Sesame Cracker Salad.webp": 7095,
	"./Smoothies - Avocado.webp": 671,
	"./Smoothies - Berry.webp": 9925,
	"./Smoothies - Mango.webp": 6735,
	"./Smoothies - Strawberry.webp": 7026,
	"./Smoothies - Taro.webp": 4259,
	"./Sorbet - Lemon.webp": 854,
	"./Sorbet - Mango.webp": 3283,
	"./Sorbet - Orange.webp": 7269,
	"./Sorbet - Strawberry.webp": 8166,
	"./Spicy Cheezy Chicken.webp": 72,
	"./Spicy Cheezy Octopus.webp": 2078,
	"./Strawberry Boba Milk.webp": 3717,
	"./Strawberry Macchiato.webp": 2275,
	"./Strawberry Smoothies.webp": 277,
	"./Strawberry Sorbet.webp": 8223,
	"./Strawberry TEA.webp": 4714,
	"./Street Style BANH MI (Banh Mi Tron).webp": 285,
	"./Sunrise - Mango ITALIAN.webp": 1049,
	"./Sunset - Orange ITALIAN.webp": 8070,
	"./TARO MILKTEA.webp": 7450,
	"./TEA.webp": 9129,
	"./TROPICAL PEACH MANGO YOGURT.webp": 972,
	"./Taro BoBa Milk.webp": 4915,
	"./Taro Smoothies.webp": 2232,
	"./Tea - Grapefruit.webp": 9921,
	"./Tea - Lychee.webp": 2534,
	"./Tea - Mango.webp": 724,
	"./Tea - Peach.webp": 2227,
	"./Tea - Peppermint.webp": 2202,
	"./Tea - Rose.webp": 7633,
	"./Tea - Strawberry.webp": 7355,
	"./Tiger Sugar Boba Milk.webp": 1387,
	"./Tiramisu MILKTEA.webp": 4150,
	"./Tiramisu Mocha Iceblend.webp": 1619,
	"./UBE Coffee.webp": 3435,
	"./Vietnamese COFFEE - BLACK.webp": 2650,
	"./Vietnamese COFFEE - MILK.webp": 1840,
	"./WONDERLAND MILKTEA.webp": 2004,
	"./Yogurt Cookies.webp": 7220,
	"./Yogurt Honeydew (J) Peach (S) Smoothies.webp": 2285,
	"./Yogurt Mango (J) Orange (S) Smoothies.webp": 59,
	"./Yogurt Matcha Iceblend.webp": 7509,
	"./Yogurt Pineapple (J) Peppermint (S) Smoothies.webp": 2353,
	"./Yogurt Strawberry (J) Mango.webp": 4027,
	"./ic_test.webp": 4510,
	"assets/temp/1102 Boba Bunny.webp": 5257,
	"assets/temp/1102 Combo Platter.webp": 5819,
	"assets/temp/1102 Matcha Iceblend.webp": 2691,
	"assets/temp/1102 TOTE.webp": 7429,
	"assets/temp/Almond Milktea.webp": 8697,
	"assets/temp/Almond Mocha Iceblend.webp": 4670,
	"assets/temp/Avocado Smoothies.webp": 339,
	"assets/temp/BEEF Ball.webp": 3996,
	"assets/temp/Berries Smoothies.webp": 4626,
	"assets/temp/Black Milktea.webp": 1059,
	"assets/temp/Blue Ocean - Blue Curacao Italian.webp": 6138,
	"assets/temp/Boba Milk - Brulee On The Tiger.webp": 9349,
	"assets/temp/Boba Milk - Chocolate Boba Milk.webp": 8038,
	"assets/temp/Boba Milk - Honey Boba Milk.webp": 4995,
	"assets/temp/Boba Milk - Matcha Boba Milk.webp": 2170,
	"assets/temp/Boba Milk - Orange Boba Milk.webp": 2424,
	"assets/temp/Boba Milk - Strawberry Boba Milk.webp": 3007,
	"assets/temp/Boba Milk - Tige Sugar Boba Milk.webp": 2847,
	"assets/temp/Boba Milk - Tiger Sugar Boba Milk.webp": 6789,
	"assets/temp/Brulee On The Tiger.webp": 5319,
	"assets/temp/CHAI TEA Pumpkin Latte.webp": 5140,
	"assets/temp/CHICKEN Dumpling.webp": 3614,
	"assets/temp/CREME BRULEE.webp": 9036,
	"assets/temp/Caramel MILKTEA.webp": 1757,
	"assets/temp/Caramel Mocha Iceblend.webp": 1794,
	"assets/temp/Cheese Stick.webp": 4676,
	"assets/temp/Chocolate Boba Milk.webp": 7168,
	"assets/temp/Chocolate Cookies.webp": 9938,
	"assets/temp/Chocolate MILKTEA.webp": 5386,
	"assets/temp/Chocolate Matcha Iceblend.webp": 6791,
	"assets/temp/Chocolate Mocha Iceblend.webp": 4647,
	"assets/temp/Chocolate Pumpkin MOCHA.webp": 5275,
	"assets/temp/Cinnamon Pumpkin MILKTEA.webp": 2585,
	"assets/temp/Coconut Coffee.webp": 1332,
	"assets/temp/Coconut Cookies.webp": 9247,
	"assets/temp/Coconut MILKTEA.webp": 523,
	"assets/temp/Coconut Mocha Iceblend.webp": 452,
	"assets/temp/Coffee - Coconut Coffee.webp": 5911,
	"assets/temp/Coffee - Coffee latte.webp": 1700,
	"assets/temp/Coffee - Egg Coffee.webp": 4169,
	"assets/temp/Coffee - Macchiato coffee.webp": 3043,
	"assets/temp/Coffee - Matcha Coffee.webp": 5258,
	"assets/temp/Coffee - Mocha.webp": 8940,
	"assets/temp/Coffee - Salted Caramel Coffee.webp": 8434,
	"assets/temp/Coffee - Ube Coffee.webp": 4860,
	"assets/temp/Coffee - Vietnamese Black Coffee.webp": 4722,
	"assets/temp/Coffee - Vietnamese Milk Coffee.webp": 6084,
	"assets/temp/Coffee Latte.webp": 9543,
	"assets/temp/Coffee MILKTEA.webp": 1042,
	"assets/temp/De Lavie - Honeydew FRECH.webp": 2661,
	"assets/temp/De Lune - Mango FRENCH.webp": 619,
	"assets/temp/De Soleil - Pineapple FRENCH.webp": 4609,
	"assets/temp/De Valentino - Strawberry.webp": 806,
	"assets/temp/Dragonfruit Tea.webp": 3090,
	"assets/temp/Dua hau.webp": 9627,
	"assets/temp/EGG Coffee.webp": 1350,
	"assets/temp/Egg Roll.webp": 9557,
	"assets/temp/FISH Ball.webp": 1220,
	"assets/temp/FLAN.webp": 7264,
	"assets/temp/French Smoothies - Yogurt Honeydew Peach.webp": 9693,
	"assets/temp/French Smoothies - Yogurt Mango Orange.webp": 4209,
	"assets/temp/French Smoothies - Yogurt Pineapple Peppermint.webp": 155,
	"assets/temp/French Smoothies - Yogurt Strawberry Mango.webp": 4578,
	"assets/temp/French Sodas - De Lavie (Honeydrew).webp": 9506,
	"assets/temp/French Sodas - De Lune (Mango).webp": 4686,
	"assets/temp/French Sodas - De Soleil (Pineapple).webp": 2384,
	"assets/temp/French Sodas - De Valentino (Strawberry).webp": 5917,
	"assets/temp/GREEN APPLE TEAMILKTEA.webp": 9261,
	"assets/temp/Grapefruit TEA.webp": 8628,
	"assets/temp/Green Apple Tea.webp": 2874,
	"assets/temp/Greenthai milktea.webp": 8333,
	"assets/temp/Grilled Egg Cake (Banh Trung Nuong).webp": 8184,
	"assets/temp/Guava Tea.webp": 479,
	"assets/temp/HAT.webp": 1586,
	"assets/temp/Hand mash Strawberry Tea.webp": 7892,
	"assets/temp/Hazelnut MILKTEA.webp": 9875,
	"assets/temp/Hazelnut Mocha Iceblend.webp": 3980,
	"assets/temp/Honey Boba Milk.webp": 5021,
	"assets/temp/Honey Lemon Tea.webp": 4257,
	"assets/temp/Honey Matcha Iceblend.webp": 9802,
	"assets/temp/Hot Fire Bread (Banh Mi Muoi Ot).webp": 3387,
	"assets/temp/Iceblend - 1102 Matcha.webp": 7416,
	"assets/temp/Iceblend - Chocolate Cookies.webp": 2961,
	"assets/temp/Iceblend - Chocolate Matcha.webp": 3222,
	"assets/temp/Iceblend - Coconut Cookies.webp": 9388,
	"assets/temp/Iceblend - Honey Matcha.webp": 1457,
	"assets/temp/Iceblend - Peppermint Cookies.webp": 9363,
	"assets/temp/Iceblend - Yogurt Cookies.webp": 9369,
	"assets/temp/Iceblend - Yogurt Matcha.webp": 9278,
	"assets/temp/Italian Sodas - Blue Ocean (Blue Curacao).webp": 9173,
	"assets/temp/Italian Sodas - Pinky Dream (Rose).webp": 8820,
	"assets/temp/Italian Sodas - Ruby (Grapefruit).webp": 3768,
	"assets/temp/Italian Sodas - Sapphire (Lavender).webp": 8614,
	"assets/temp/Italian Sodas - Sunrise (Mango).webp": 5780,
	"assets/temp/Italian Sodas - Sunset (Orange).webp": 9053,
	"assets/temp/JASMINE GREEN MILKTEA.webp": 5838,
	"assets/temp/Key chain Bunny.webp": 9673,
	"assets/temp/LAVENDER TEA.webp": 3688,
	"assets/temp/Large size Bunny Plushie.webp": 4263,
	"assets/temp/Lavender MILKTEA.webp": 2445,
	"assets/temp/Lavender TEA (2).webp": 8505,
	"assets/temp/Lemon Sorbet.webp": 2347,
	"assets/temp/Lemonade Jasmine Tea.webp": 8943,
	"assets/temp/Luu.webp": 645,
	"assets/temp/Lychee MILKTEA.webp": 5672,
	"assets/temp/Lychee TEA.webp": 1297,
	"assets/temp/MANGO MILK TEA.webp": 4222,
	"assets/temp/MAPLE Pumpkin Latte.webp": 5280,
	"assets/temp/MATCHA Coffee.webp": 191,
	"assets/temp/MILKTEA ON THE FIRE.webp": 4874,
	"assets/temp/Macaroon.webp": 1309,
	"assets/temp/Macchiato Coffee.webp": 8412,
	"assets/temp/Macchiato TEA.webp": 6146,
	"assets/temp/Macchiato Tea - Black tea.webp": 5164,
	"assets/temp/Macchiato Tea - Jasmine tea.webp": 9258,
	"assets/temp/Macchiato Tea - Oolong Tea.webp": 209,
	"assets/temp/Macchiato Tea - Strawberry Macchiato.webp": 9801,
	"assets/temp/Mango Smoothies.webp": 3524,
	"assets/temp/Mango Sorbet.webp": 9348,
	"assets/temp/Mango TEA.webp": 7003,
	"assets/temp/Matcha Boba Milk.webp": 2092,
	"assets/temp/Matcha MILKTEA.webp": 158,
	"assets/temp/Mayo Springroll (Banh Trang Cuon Bo).webp": 809,
	"assets/temp/Medium size Bunny Plushie.webp": 2521,
	"assets/temp/Milktea.webp": 7296,
	"assets/temp/Mocha Coffee.webp": 3303,
	"assets/temp/Mocha Iceblend - Almond Mocha.webp": 7519,
	"assets/temp/Mocha Iceblend - Caramel Mocha.webp": 5449,
	"assets/temp/Mocha Iceblend - Chocolate Mocha.webp": 8810,
	"assets/temp/Mocha Iceblend - Coconut Mocha.webp": 3207,
	"assets/temp/Mocha Iceblend - Hazelnut Mocha.webp": 217,
	"assets/temp/Mocha Iceblend - Tiramisu Mocha.webp": 4304,
	"assets/temp/OOLONG MILKTEA ( DARK ROAST).webp": 3934,
	"assets/temp/OOLONG MILKTEA (DARK ROAST).webp": 1450,
	"assets/temp/ORANGE MILKTEA.webp": 3484,
	"assets/temp/Orange Boba Milk.webp": 1646,
	"assets/temp/Orange Sorbet.webp": 1674,
	"assets/temp/Organic Milktea - Dark Roast Oolong.webp": 1985,
	"assets/temp/Organic Milktea - Earl Grey Black.webp": 7426,
	"assets/temp/Organic Milktea - Green Thai.webp": 4821,
	"assets/temp/Organic Milktea - Jasmine Green Tea.webp": 5270,
	"assets/temp/Organic Milktea - Milktea On The Fire.webp": 5207,
	"assets/temp/Organic Milktea - Plant Pot Milktea.webp": 9427,
	"assets/temp/Organic Milktea - Red Thai.webp": 5065,
	"assets/temp/Organic Milktea - Wonderland Milktea.webp": 6411,
	"assets/temp/PANNA COTTA.webp": 8284,
	"assets/temp/PHA LAU.webp": 8730,
	"assets/temp/PLANT POT MILKTEA.webp": 5962,
	"assets/temp/Peach Jasmine MACCHIATO TEA.webp": 5454,
	"assets/temp/Peach MILKTEA.webp": 5093,
	"assets/temp/Peach ORANGE LEMONGRASS Jasmine TEA.webp": 3052,
	"assets/temp/Peach PASSIONFRUIT Jasmine TEA.webp": 3656,
	"assets/temp/Peach Series - Peach Jasmine Macchiato Tea.webp": 4301,
	"assets/temp/Peach Series - Peach Orange Lemongrass Jasmine Tea.webp": 9155,
	"assets/temp/Peach Series - Peach Passionfruit Jasmine Tea.webp": 3669,
	"assets/temp/Peach Series - Tropical Peach Mango Yogurt.webp": 7047,
	"assets/temp/Peach TEA.webp": 672,
	"assets/temp/Peppermint Cookies.webp": 6958,
	"assets/temp/Peppermint Tea.webp": 4699,
	"assets/temp/Pinky Dream - Rose ITALIAN.webp": 1975,
	"assets/temp/RED THAI MILKTEA.webp": 5,
	"assets/temp/Red Thai Milk Tea.webp": 2159,
	"assets/temp/Rice Paper On the WOK (Banh Trang Chien).webp": 7430,
	"assets/temp/Rice Paper Pot Sticker.webp": 7777,
	"assets/temp/Rice Paper Salad (Banh Trang Tron).webp": 9976,
	"assets/temp/Rice Paper Tacos (Banh Trang Nuong).webp": 5123,
	"assets/temp/Rose MILKTEA.webp": 6533,
	"assets/temp/Rose TEA.webp": 4128,
	"assets/temp/Ruby - Grapefruit ITALIAN.webp": 1349,
	"assets/temp/SALTED CARAMEL COFFEE.webp": 6611,
	"assets/temp/SHRIMP Ball.webp": 8435,
	"assets/temp/SOURSOP JASMINE TEA.webp": 3177,
	"assets/temp/STRAWBERRY MILKTEA.webp": 3531,
	"assets/temp/Sapphire - Lavender ITALIAN.webp": 5387,
	"assets/temp/Sausage.webp": 464,
	"assets/temp/Sesame Cracker Salad.webp": 7095,
	"assets/temp/Smoothies - Avocado.webp": 671,
	"assets/temp/Smoothies - Berry.webp": 9925,
	"assets/temp/Smoothies - Mango.webp": 6735,
	"assets/temp/Smoothies - Strawberry.webp": 7026,
	"assets/temp/Smoothies - Taro.webp": 4259,
	"assets/temp/Sorbet - Lemon.webp": 854,
	"assets/temp/Sorbet - Mango.webp": 3283,
	"assets/temp/Sorbet - Orange.webp": 7269,
	"assets/temp/Sorbet - Strawberry.webp": 8166,
	"assets/temp/Spicy Cheezy Chicken.webp": 72,
	"assets/temp/Spicy Cheezy Octopus.webp": 2078,
	"assets/temp/Strawberry Boba Milk.webp": 3717,
	"assets/temp/Strawberry Macchiato.webp": 2275,
	"assets/temp/Strawberry Smoothies.webp": 277,
	"assets/temp/Strawberry Sorbet.webp": 8223,
	"assets/temp/Strawberry TEA.webp": 4714,
	"assets/temp/Street Style BANH MI (Banh Mi Tron).webp": 285,
	"assets/temp/Sunrise - Mango ITALIAN.webp": 1049,
	"assets/temp/Sunset - Orange ITALIAN.webp": 8070,
	"assets/temp/TARO MILKTEA.webp": 7450,
	"assets/temp/TEA.webp": 9129,
	"assets/temp/TROPICAL PEACH MANGO YOGURT.webp": 972,
	"assets/temp/Taro BoBa Milk.webp": 4915,
	"assets/temp/Taro Smoothies.webp": 2232,
	"assets/temp/Tea - Grapefruit.webp": 9921,
	"assets/temp/Tea - Lychee.webp": 2534,
	"assets/temp/Tea - Mango.webp": 724,
	"assets/temp/Tea - Peach.webp": 2227,
	"assets/temp/Tea - Peppermint.webp": 2202,
	"assets/temp/Tea - Rose.webp": 7633,
	"assets/temp/Tea - Strawberry.webp": 7355,
	"assets/temp/Tiger Sugar Boba Milk.webp": 1387,
	"assets/temp/Tiramisu MILKTEA.webp": 4150,
	"assets/temp/Tiramisu Mocha Iceblend.webp": 1619,
	"assets/temp/UBE Coffee.webp": 3435,
	"assets/temp/Vietnamese COFFEE - BLACK.webp": 2650,
	"assets/temp/Vietnamese COFFEE - MILK.webp": 1840,
	"assets/temp/WONDERLAND MILKTEA.webp": 2004,
	"assets/temp/Yogurt Cookies.webp": 7220,
	"assets/temp/Yogurt Honeydew (J) Peach (S) Smoothies.webp": 2285,
	"assets/temp/Yogurt Mango (J) Orange (S) Smoothies.webp": 59,
	"assets/temp/Yogurt Matcha Iceblend.webp": 7509,
	"assets/temp/Yogurt Pineapple (J) Peppermint (S) Smoothies.webp": 2353,
	"assets/temp/Yogurt Strawberry (J) Mango.webp": 4027,
	"assets/temp/ic_test.webp": 4510
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9152;